export const returnRnagemasterData = () => {
  const rangeMaterData = [];
  return rangeMaterData;
};
export const onnumberKeyDown = (event) => {
  // Check if the pressed key is 'e' or '.'
  if (event.key === "e" || event.key === ".") {
    event.preventDefault(); // Prevent typing 'e' and '.'
  }
};
